import React from 'react'
import Activated from '../../components/User/MembershipActivated';

const MembershipActivated = () => {
  return (
    <Activated />
  )
}

export default MembershipActivated;